import React, { memo, useCallback, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RouteOnMount } from 'utils/routes';
import EmailEditor from './marketing/EmailEditor';
import InitialSetup from './marketing/InitialSetup';
import MarketingCampaigns from './marketing';
import Subscribers from './marketing/Subscribers';
import CampaignDetails from './marketing/CampaignDetails';
import SetupCheckerWrapper from './marketing/wrappers/SetupCheckerWrapper';
import MarketingSettings from './marketing/settings';

const MarketingCampaignsContainer = memo(() => {
    const [isSubscribersOpen, setIsSubscribersOpen] = useState(false);
    const handleOpenSubscribers = useCallback(() => {
        setIsSubscribersOpen(true);
    }, []);

    const handleCloseSubscribers = useCallback(() => {
        setIsSubscribersOpen(false);
    }, []);

    return (
        <>
            <Routes>
                <Route
                    path="/"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns"
                            element={
                                <SetupCheckerWrapper>
                                    <MarketingCampaigns
                                        onManageSubscribers={handleOpenSubscribers}
                                    />
                                </SetupCheckerWrapper>
                            }
                        />
                    }
                />
                <Route
                    path="/email-editor"
                    element={
                        <RouteOnMount title="page_title_email_editor" element={<EmailEditor />} />
                    }
                />
                <Route
                    path="/initial-setup"
                    element={
                        <RouteOnMount
                            title="page_title_initial_setup"
                            onMount={() => {}}
                            element={<InitialSetup onManageSubscribers={handleOpenSubscribers} />}
                        />
                    }
                />
                <Route
                    path="/new"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_create"
                            element={
                                <SetupCheckerWrapper>
                                    <CampaignDetails />
                                </SetupCheckerWrapper>
                            }
                        />
                    }
                />
                <Route
                    path="/edit/:id"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_edit"
                            element={
                                <SetupCheckerWrapper>
                                    <CampaignDetails />
                                </SetupCheckerWrapper>
                            }
                        />
                    }
                />
                <Route
                    path="/settings/*"
                    element={
                        <RouteOnMount
                            title="page_title_marketing_campaigns_settings"
                            element={
                                <SetupCheckerWrapper>
                                    <MarketingSettings />
                                </SetupCheckerWrapper>
                            }
                        />
                    }
                />
            </Routes>
            {isSubscribersOpen && <Subscribers onClose={handleCloseSubscribers} />}
        </>
    );
});

export default MarketingCampaignsContainer;
